module.exports = __webpack_public_path__ + "img/share.8f965a30.svg";